import React from "react";
import {makeApiUrl} from "../helpers/makeApiUrl";
import {requestOption} from "../helpers/requestOption";
import {handleResponse} from "../helpers/handleResponse";
import {Loading} from "./Loading";
import Error404 from "./Error404";


class StaticPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            title: null,
            content: null,
            isLoading: false,
            notFound: false

        };
    }

    static async fetchData(page) {
        let url = makeApiUrl('page/' + page);
        let jsonData = null;
        return fetch(url, requestOption())
            .then(handleResponse)
            .then(_jsonData => {
                return _jsonData;
            });
    }

    loadData(page) {
        if (page) {
            this.setState({isLoading: true});
            StaticPage.fetchData(page).then(json => {
                if (typeof json.content == 'undefined') {
                    this.setState({notFound: true, isLoading:false})
                } else {
                    this.setState({isLoading:false, title: json.title, content: json.content});
                }

            })
        } else {
            this.setState({notFound: true});
        }
    }

    componentDidMount() {
        this.loadData(this.props);
    }

    render() {
        if (this.state.isLoading) return <Loading/>;
        if (this.state.notFound) return <Error404/>;
        let title = this.state.title ? <h1>{this.state.title}</h1> : '';
        return <div className='static-page'>
            {title}
            <div className='page-body' dangerouslySetInnerHTML={{__html: this.state.content}}></div>
        </div>;
    }
}

export default StaticPage
